module.exports = __webpack_public_path__ + "img/feedback old.a8f38868.png";